import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import { Form, Button, message, Input } from 'antd';
import { parse } from 'query-string';
import WhiteBox from '@/components/layout/whiteBox';
import TicketTitle from '@/components/ticketTitle';
import { idValid } from '@/utils/formValidator';
import styles from './index.less';

class AddTaxOfficer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
    this.formRef = React.createRef();
  }

  componentDidMount() {
    // 获取URL参数
    const { serialNo, province, qrcodeId } = parse(window.location.search);
    
    // 存储参数到state中
    this.setState({
      serialNo,
      province,
      qrcodeId
    });
  }

  handleSubmit = async () => {
    try {
      const values = await this.formRef.current.validateFields();
      console.log(values, '===values');
      
      this.setState({ loading: true });
      
      // 跳转到二维码页面，传递表单数据
      const { serialNo, province } = this.state;
      const params = new URLSearchParams({
        serialNo,
        province,
        fullName: values.taxOfficerName,
        idCard: values.taxOfficerIdCard
      });
      
      setTimeout(() => {
        this.props.history.replace(`/addTaxOfficerQrCode?${params.toString()}`);
      }, 500);
      
    } catch (error) {
      console.error('表单验证失败:', error);
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const { loading } = this.state;

    return (
      <WhiteBox>
        <TicketTitle {...this.props} />
        <div className={styles.container}>
          
          <Form
            ref={this.formRef}
            layout="vertical"
            className={styles.form}
          >
            <Form.Item
              label={<span>办税员姓名</span>}
              name="taxOfficerName"
              rules={[
                { required: true, message: '请输入办税员姓名' },
                { min: 2, max: 20, message: '姓名字符长度2-20' },
              ]}
            >
              <Input
                size="large"
                placeholder="请输入法人以外的其他办税员姓名"
                maxLength={20}
              />
            </Form.Item>

            <Form.Item
              label={<span>办税员身份证号</span>}
              name="taxOfficerIdCard"
              rules={[
                { required: true, message: '请输入办税员身份证号' },
                { 
                  validator: (_, value) => idValid(value, '请输入正确的身份证号码')
                }
              ]}
            >
              <Input
                size="large"
                placeholder="请输入上方办税员的身份证号"
                maxLength={18}
              />
            </Form.Item>
          </Form>

          <Button
            type="primary"
            className={styles.submitButton}
            onClick={this.handleSubmit}
            loading={loading}
            block
          >
            下一步
          </Button>
        </div>
      </WhiteBox>
    );
  }
}

AddTaxOfficer.propTypes = {
  history: PropTypes.object,
};

export default inject()(observer(AddTaxOfficer));
